export interface IPhotoRotation {
  rotation: number;
  imageFlipped: boolean;
}

const rotations = [90, 180, 270];

export const getRotation = (photoRotation: any): IPhotoRotation => {
  let parsedPhotoRotation;
  try {
    if (photoRotation) parsedPhotoRotation = parseInt(photoRotation, 10); // When saving reverts back to string
  } catch (e) { /* Ignore */ }
  if (parsedPhotoRotation) {
    return {
      rotation: parsedPhotoRotation,
      imageFlipped: parsedPhotoRotation !== rotations[1],
    };
  }
  return null;
};
